import "@babel/polyfill";
import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";

let location = window.location.href,
  host = "https://web-test.purepurr.tech";

if (location.startsWith("https://admin.purepurr.tech")) {
  host = "https://web.purepurr.tech";
}

Vue.config.productionTip = false;
Vue.prototype.$hostname = host + "/api"; //http://10.39.224.63

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");